export default "__VITE_ASSET__S6rnKgKk__"